export default __webpack_public_path__ + "static/media/medicenter-wheretofindus.2dfe4850.PNG";